module.exports = __webpack_public_path__ + "img/title-vi.826a11d9.png";